/* 🤖 this file was generated by svg-to-ts*/
export const icoBookmark: {
  name: 'bookmark';
  data: string;
} = {
  name: 'bookmark',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 2H7a2 2 0 00-2 2v17l.006.113a1 1 0 001.634.655L12 17.302l5.36 4.466A1 1 0 0019 21V4a2 2 0 00-2-2zM7 4h10v14.864l-4.36-3.632-.105-.077a1 1 0 00-1.175.077L7 18.864V4z" fill="#909090"/></svg>`
};
